import React from "react";
import PropTypes from "prop-types";
import Overlay from "../../Overlay";

const AttachmentView = ({ src, onClose }) => {
  return (
    <Overlay
      style={{
        alignItems: "flex-start",
      }}
      onClose={onClose}
      content={
        <div className="image-preview">
          <img src={src} className="image-preview__image" alt="preview" />
        </div>
      }
    />
  );
};

AttachmentView.propTypes = {};

export default AttachmentView;
